/** @module components/modals */
import CalendlyModal from './CalendlyModal';

export default CalendlyModal;
